import { insertSuggestionChar } from "../../core/suggest/suggest";
import { updateEmojiSuggesterMatchOffset } from "./plugins";
export function createEmoji(view, emoji, from, to) {
    const tr = view.state.tr;
    updateEmojiSuggesterMatchOffset(tr, 0);
    tr.insertText(emoji, from, to);
    view.dispatch(tr);
    view.focus();
}
export function startEmojiSuggester(view, from, to) {
    const tr = view.state.tr;
    updateEmojiSuggesterMatchOffset(tr, 0);
    if (from && to) {
        tr.deleteRange(from, to);
    }
    view.dispatch(tr);
    // force the emoji suggester to be started in a different transaction
    // to avoid weird suggester state behaviors
    view.dispatch(insertSuggestionChar(view.state, view.state.tr, ":"));
    view.focus();
}
